import SimpleBar from 'simplebar-react'
import { styled } from '@mui/material/styles'

const ScrollbarWrapper = (props) => <SimpleBar autoHide={false} {...props} />

export const Scrollbar = styled(ScrollbarWrapper)``
